import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { store } from './store'; // your Redux store
import { setLanguage } from './store/languageSlice';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: require('./locales/en.json')
      },
      de: {
        translation: require('./locales/de.json')
      }
    },
    lng: store.getState().language.currentLanguage, // Get initial language from Redux
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Sync i18n language changes with Redux
i18n.on('languageChanged', (lng) => {
  store.dispatch(setLanguage(lng));
});

export default i18n;